import { STORE_USER_DATA } from "./Actions";

const initialState = {
  token: null,
  client: null,
};

export default function UserReducer(state = initialState, action = {}) {
  switch (action.type) {
    case STORE_USER_DATA: {
      return {
        ...state,
        token: action.token,
        client: action.client,
      };
    }

    default:
      return state;
  }
}
